import { createSlice } from "@reduxjs/toolkit";

interface AuthState {
  auth_token: string;
}

const initialState: AuthState = {
  auth_token: "",
};

export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    // setAuthToken removed — token is no longer stored in Redux.
    // The Axios interceptor calls auth.currentUser.getIdToken() fresh before every request.
    ClearAuth: (state) => {
      state.auth_token = "";
    },
  },
});

// Action creators are generated for each case reducer function
export const { ClearAuth } = authSlice.actions;

export default authSlice.reducer;
